/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AmenityCollectionResponse } from '../models/amenity-collection-response';
import { getAllTenants } from '../fn/tenants/get-all-tenants';
import { GetAllTenants$Params } from '../fn/tenants/get-all-tenants';
import { getTenantAmenities } from '../fn/tenants/get-tenant-amenities';
import { GetTenantAmenities$Params } from '../fn/tenants/get-tenant-amenities';
import { getTenantById } from '../fn/tenants/get-tenant-by-id';
import { GetTenantById$Params } from '../fn/tenants/get-tenant-by-id';
import { getTenantConfigurations } from '../fn/tenants/get-tenant-configurations';
import { GetTenantConfigurations$Params } from '../fn/tenants/get-tenant-configurations';
import { HalJson } from '../models/hal-json';
import { postSandboxTenant } from '../fn/tenants/post-sandbox-tenant';
import { PostSandboxTenant$Params } from '../fn/tenants/post-sandbox-tenant';
import { postTenant } from '../fn/tenants/post-tenant';
import { PostTenant$Params } from '../fn/tenants/post-tenant';
import { PutResponse } from '../models/put-response';
import { putTenantAmenities } from '../fn/tenants/put-tenant-amenities';
import { PutTenantAmenities$Params } from '../fn/tenants/put-tenant-amenities';
import { Tenant } from '../models/tenant';
import { TenantConfigurationsMetadata } from '../models/tenant-configurations-metadata';
import { Tenants } from '../models/tenants';
import { updateAggregator } from '../fn/tenants/update-aggregator';
import { UpdateAggregator$Params } from '../fn/tenants/update-aggregator';
import { UpdateAmenitiesResponse } from '../models/update-amenities-response';
import { updateTenant } from '../fn/tenants/update-tenant';
import { UpdateTenant$Params } from '../fn/tenants/update-tenant';

@Injectable({ providedIn: 'root' })
export class TenantsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllTenants()` */
  static readonly GetAllTenantsPath = '/tenants';

  /**
   * Gets all tenants.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTenants$Response(params?: GetAllTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<Tenants>> {
    return getAllTenants(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all tenants.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTenants(params?: GetAllTenants$Params, context?: HttpContext): Observable<Tenants> {
    return this.getAllTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tenants>): Tenants => r.body)
    );
  }

  /** Path part for operation `postTenant()` */
  static readonly PostTenantPath = '/tenants';

  /**
   * Create a specified tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postTenant$Response(params: PostTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<Tenant>> {
    return postTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a specified tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postTenant(params: PostTenant$Params, context?: HttpContext): Observable<Tenant> {
    return this.postTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tenant>): Tenant => r.body)
    );
  }

  /** Path part for operation `getTenantById()` */
  static readonly GetTenantByIdPath = '/tenants/{tenantId}';

  /**
   * Gets a specified tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantById$Response(params: GetTenantById$Params, context?: HttpContext): Observable<StrictHttpResponse<Tenant>> {
    return getTenantById(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a specified tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantById(params: GetTenantById$Params, context?: HttpContext): Observable<Tenant> {
    return this.getTenantById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Tenant>): Tenant => r.body)
    );
  }

  /** Path part for operation `updateTenant()` */
  static readonly UpdateTenantPath = '/tenants/{tenantId}';

  /**
   * Updates a specified tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenant$Response(params: UpdateTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
    return updateTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a specified tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTenant(params: UpdateTenant$Params, context?: HttpContext): Observable<PutResponse> {
    return this.updateTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<PutResponse>): PutResponse => r.body)
    );
  }

  /** Path part for operation `getTenantConfigurations()` */
  static readonly GetTenantConfigurationsPath = '/tenant-configurations';

  /**
   * Gets all Tenant configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantConfigurations$Response(params: GetTenantConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantConfigurationsMetadata>> {
    return getTenantConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all Tenant configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantConfigurations(params: GetTenantConfigurations$Params, context?: HttpContext): Observable<TenantConfigurationsMetadata> {
    return this.getTenantConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<TenantConfigurationsMetadata>): TenantConfigurationsMetadata => r.body)
    );
  }

  /** Path part for operation `updateAggregator()` */
  static readonly UpdateAggregatorPath = '/tenants/{tenantId}/aggregators';

  /**
   * Updates a specified tenant's aggregators.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAggregator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAggregator$Response(params: UpdateAggregator$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
    return updateAggregator(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a specified tenant's aggregators.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAggregator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAggregator(params: UpdateAggregator$Params, context?: HttpContext): Observable<PutResponse> {
    return this.updateAggregator$Response(params, context).pipe(
      map((r: StrictHttpResponse<PutResponse>): PutResponse => r.body)
    );
  }

  /** Path part for operation `getTenantAmenities()` */
  static readonly GetTenantAmenitiesPath = '/tenant-amenities';

  /**
   * Fetch tenant amenities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantAmenities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantAmenities$Response(params: GetTenantAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<AmenityCollectionResponse>> {
    return getTenantAmenities(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetch tenant amenities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantAmenities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantAmenities(params: GetTenantAmenities$Params, context?: HttpContext): Observable<AmenityCollectionResponse> {
    return this.getTenantAmenities$Response(params, context).pipe(
      map((r: StrictHttpResponse<AmenityCollectionResponse>): AmenityCollectionResponse => r.body)
    );
  }

  /** Path part for operation `putTenantAmenities()` */
  static readonly PutTenantAmenitiesPath = '/tenant-amenities';

  /**
   * Update tenant amenities.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putTenantAmenities()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putTenantAmenities$Response(params: PutTenantAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateAmenitiesResponse>> {
    return putTenantAmenities(this.http, this.rootUrl, params, context);
  }

  /**
   * Update tenant amenities.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putTenantAmenities$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putTenantAmenities(params: PutTenantAmenities$Params, context?: HttpContext): Observable<UpdateAmenitiesResponse> {
    return this.putTenantAmenities$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateAmenitiesResponse>): UpdateAmenitiesResponse => r.body)
    );
  }

  /** Path part for operation `postSandboxTenant()` */
  static readonly PostSandboxTenantPath = '/tenants/sandbox';

  /**
   * Creates a sandbox tenant for demo. (DEV and STAGE environments only).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSandboxTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postSandboxTenant$Response(params: PostSandboxTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<HalJson>> {
    return postSandboxTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a sandbox tenant for demo. (DEV and STAGE environments only).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSandboxTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postSandboxTenant(params: PostSandboxTenant$Params, context?: HttpContext): Observable<HalJson> {
    return this.postSandboxTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<HalJson>): HalJson => r.body)
    );
  }

}
